import { render, staticRenderFns } from "./TradeIpo.vue?vue&type=template&id=fac67aec"
import script from "./TradeIpo.vue?vue&type=script&lang=js"
export * from "./TradeIpo.vue?vue&type=script&lang=js"
import style0 from "../../sass/trade/ipo.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports